import { match } from 'ts-pattern'
import { z } from 'zod'
import { PulsingDot } from '../pulsing-dot.tsx'
import * as styles from './activity-step-card-skeleton.css.ts'
import { DefaultIndicator } from './default-indicator.tsx'

export const ActivityStepCardSkeletonVariantSchema = z.enum(['default', 'on-deck'])
export type ActivityStepCardSkeletonVariant = z.infer<typeof ActivityStepCardSkeletonVariantSchema>

export type ActivityStepCardSkeletonProps = {
  variant?: ActivityStepCardSkeletonVariant
}

export const ActivityStepCardSkeleton: React.FC<ActivityStepCardSkeletonProps> = ({ variant = 'default' }) => {
  const indicator = match(variant)
    .with('default', () => <DefaultIndicator size={24} />)
    .with('on-deck', () => <PulsingDot variant="on-deck" size={24} />)
    .exhaustive()

  return (
    <div className={styles.card} role="listitem" aria-hidden="true">
      {indicator}
      <div className={styles.content({ variant })}>
        <div className={styles.shimmerBar({ variant, size: 'title' })} />
        <div className={styles.shimmerBar({ variant, size: 'description' })} />
      </div>
    </div>
  )
}
